var React = require('react');

function Facebook (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M6.135 18.34H2.237V9.193H.289V6.04h1.948V4.147c0-2.572 1.1-4.102 4.225-4.102h2.601V3.2H7.437c-1.216 0-1.297.44-1.297 1.263L6.135 6.04H9.08l-.345 3.152H6.135v9.149z"}));
}

Facebook.defaultProps = {"width":"1em","height":"1em","viewBox":"0 0 10 19"};

module.exports = Facebook;

Facebook.default = Facebook;
